const themeRuntime = require('../../../../react/src/theme/themeRuntime');

export default function themePref() {
  return themeRuntime;
}
